import { Component } from '@angular/core';
import { BundlesListComponent } from "../../../../../components/admin-dashboard-component/promotions/bundles-managment/bundles-list-component/bundles-list-component";

@Component({
  selector: 'app-bundle-list-page',
  imports: [BundlesListComponent],
  templateUrl: './bundle-list-page.html',
  styleUrl: './bundle-list-page.scss'
})
export class BundleListPage {

}
